import { useContext } from "react";
import TextEditor from "../../components/Table/TextEditor";
import { context } from "../../context/authContext";
import useActions from "./acciones";
import { useNavigate } from "react-router-dom";

export default function useColumns(setSelectedRow,setModalOpen) {
  const { user } = useContext(context);
  const { handleDelete } = useActions();
  const userRoles = user?.rol || [];
  const permisos = userRoles.find((role) => role.nombre === "Templates")?.permiso || [];
  const isEditable = permisos.includes("editar");
  const canDelete = permisos.includes("borrar");
  const navigate = useNavigate();

  return [
    { field: "id", sort: "asc", cellClass: "d-flex align-items-center" },
    ...["nombre","ancho","alto","createdAt"].map((field) => ({
      field,
      flex: field === 'nombre' ? 1 : 2,
      cellClass: "d-flex align-items-center",
      cellEditor: TextEditor,
      autoHeight: true,
      editable: field === "createdAt" ? false : isEditable,
      valueFormatter: field === "createdAt" ? (params) =>{
        let date =  `${new Date(params.value).toLocaleDateString("en-GB")} 
        ${new Date(params.value).toLocaleTimeString("en-GB")}` 
        return date }: undefined,
      valueParser:
        field === "ancho" || field === "alto"
          ? (params) => Number(params.newValue) || 0
          : undefined,
      tooltipValueGetter: (params) => params.data?.[`tooltipError${field}`] || "",
      cellClassRules: {
        "is-invalid": (params) => !!params.data?.[`tooltipError${field}`],
        "is-valid": (params) => !!params.data?.[`isValid${field}`],
      },
    })),
    isEditable && {
      field: "html",
      flex: 1,
      autoHeight: true,
      cellClass: "d-flex align-items-center justify-content-center",
      cellRenderer: (data) => (
        <button onClick={() => navigate(`/templates/${data.data.id}`)} className="btn btn-primary px-2 py-1">
          Editar
        </button>
      ),
    },
    canDelete && {
      field: "eliminar",
      flex: 2,
      autoHeight: true,
      cellClass: "d-flex align-items-center justify-content-center",
      cellRenderer: (data) => (
        <button onClick={() => handleDelete(data, setSelectedRow,setModalOpen)} className="btn btn-primary px-2 py-1">
          🗑️ Eliminar
        </button>
      ),
    },
  ].filter(Boolean);
}
